export const constants = {
  desktop: {
    bannerHeight: 963,
    minWidth: 501,
  },
  phone: {
    bannerHeight: 525,
    maxWidth: 500,
  },
}

export const isHandheld = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
export const isIos = (/iPhone|iPad|iPod/i.test(navigator.userAgent))
export const formFactor = () => window.innerWidth > constants.phone.maxWidth ? 'desktop' : 'phone'
export function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}
